import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  FORGET_PASSWORD,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION,
  CHANGE_PASSWORD,
} from "./actionTypes";
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  emailPasswordResetTokenValidationSuccess,
  emailPasswordResetTokenValidationError,
  changePasswordSuccess,
  changePasswordError,
} from "./actions";

import {
  postFakeForgetPwd,
  postJwtForgetPwd,
  getNewPassowordRequest,
  emailPasswordTokenValidationRequest,
  postChangePassword,
} from "../../../helpers/fakebackend_helper";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    const response = yield call(getNewPassowordRequest, user);
    if (response) {
      yield put(userForgetPasswordSuccess(response));
    }
  } catch (error) {
    yield put(userForgetPasswordError(error));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
}

// Verify Email token request api
function* emailPasswordTokenValidation({ payload }) {
  try {
    const response = yield call(emailPasswordTokenValidationRequest, payload);
    if (response) {
      yield put(emailPasswordResetTokenValidationSuccess(response));
    }
  } catch (error) {
    yield put(emailPasswordResetTokenValidationError(error));
  }
}

export function* watchEmailPasswordTokenValidation() {
  yield takeEvery(
    EMAIL_PASSWORD_RESET_TOKEN_VALIDATION,
    emailPasswordTokenValidation
  );
}

// Change Password
function* changeUserPassword({ payload }) {
  try {
    const response = yield call(postChangePassword, payload);
    if (response) {
      yield put(changePasswordSuccess(response));
    }
  } catch (error) {
    yield put(changePasswordError(error));
  }
}

export function* watchChangeUserPassword() {
  yield takeEvery(CHANGE_PASSWORD, changeUserPassword);
}

function* forgetPasswordSaga() {
  yield all([
    fork(watchUserPasswordForget),
    fork(watchEmailPasswordTokenValidation),
    fork(watchChangeUserPassword),
  ]);
}

export default forgetPasswordSaga;
